export const emptyImageGrey = "#F6F6F9";
export const successAlertGreen = "#4CAF50";
export const errorAlertRed = "#EF5350";
export const warningAlertYellow = "#FF9800";
export const separatorLightGrey = "#26557326";